import { calculatePlayerStats } from "./cabbStats";

export const LeaguePlayersStats = (
  allPlayers,
  games,
  season,
  teams,
  activeProfile,
  statCategory,
  selectedTeamId // 👈 nuevo parámetro
) => {
  if (!activeProfile || !teams || !selectedTeamId) return [];

  // Buscar el equipo seleccionado en la lista de teams
  const playerTeam = teams.find(
    (team) => team._id.toString() === selectedTeamId
  );

  if (!playerTeam) return [];

  // Sacar todos los equipos de esa liga
  const leagueTeamIds = teams
    .filter((team) => team.league === playerTeam.league)
    .map((team) => team._id.toString());

  // Filtrar jugadores que jugaron en equipos de esa liga en esa temporada
  const filteredPlayers = allPlayers.filter((player) =>
    player.teams_history.some(
      (entry) =>
        leagueTeamIds.includes(entry.teamId?.toString()) &&
        entry.season === season
    )
  );

  // Calcular estadísticas para cada jugador filtrado
  const playerStats = filteredPlayers.map((player) => {
    const value = isNaN(calculatePlayerStats(games, player._id, statCategory))
      ? 0
      : calculatePlayerStats(games, player._id, statCategory);

    return {
      _id: player._id,
      player_name: player.player_name,
      player_lastname: player.player_lastname,
      value,
    };
  });

  // Ordenar de mayor a menor
  playerStats.sort((a, b) => b.value - a.value);

  return playerStats;
};
